<template>
  <div class="root" id="haha" :style="{ ...rootStyleObj }">
    <div class="content">
      <img :src="img0" :alt="t('common.wpsOffice')" class="logo-icon" />
      <img :src="img1" alt="" />
      <img :src="img2" alt="" class="content-icon" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, defineProps, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplateRequest from '../../data/TemplateRequest';

const props = defineProps<{
  view_key: string;
}>();

const img0 = ref('');
const img1 = ref('');
const img2 = ref('');

const rootStyleObj = reactive({
  backgroundImage: '',
});
const { t } = useI18n();

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var cardData: any = TemplateRequest.getViewDataByKey(props.view_key);
  img0.value = cardData.img0;
  img1.value = cardData.img1;
  img2.value = cardData.img2;
  rootStyleObj['backgroundImage'] = `url(${cardData.img3})`;
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  flex-direction: column;
  background-attachment: fixed;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 128px);
  flex-direction: column;
}

.logo-icon {
  width: 103px;
}

.content-icon {
  width: 90%;
  max-width: 375px;
  height: auto;
}

/* 当屏幕宽度小于等于 375px 时应用这些样式 */
@media screen and (max-width: 375px) {
  .content-icon {
    width: 70%;
  }
}

/* 当屏幕宽度大于等于 376px 时应用这些样式 */
@media screen and (min-width: 376px) {
  .content-icon {
    width: 90%;
  }
}

/** 适配 ipad mini */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .content-icon {
    width: 70%;
  }
}
</style>
